import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { selectIsAuthenticated } from '../../../screens/Login/selectors';
import { selectBuildInfo } from '../../services/deployCheck/selectors';

const year = moment().year();

const Footer = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const buildInfo = useSelector(selectBuildInfo);

  return (
    <footer className={`footer${isAuthenticated ? ' authenticated' : ''}`}>
      <div>
        © 2017-
        {year} IoTecha. All rights reserved.
      </div>
      {buildInfo?.latestTag && <div>{buildInfo.latestTag}</div>}
      <div className="footer__poweredBy">Powered by IOTECHA</div>
    </footer>
  );
};

export default Footer;
